import ResendOTPButton from './ResendOTPButton';

export default ResendOTPButton;
